export default __webpack_public_path__ + "static/media/cousteau.87e72696.jpg";